<!-- static content data from lang: question -->
<template>
  <div>
    <div class="h-100" v-loading="loading">
       <template v-if="errored">
         <div class="page-not">
           <Notfound />

          </div>
        </template>
    <template v-else>
    <base-header class="pb-6">
      <div class="row align-items-center pb-4">
        <div class="col-lg-12 col-12">
          <h6 class="h2 text-white d-inline-block mb-0">{{lang.label.EditheaderTitle}}</h6>
          <nav aria-label="breadcrumb" class="d-inline-block ml-4">
            <route-bread-crumb></route-bread-crumb>
          </nav>
        </div>
      </div>
    </base-header>
    <div class="container-fluid mt--6">
      <div>
        <card class="no-border-card mb-0" body-classes="px-0 pb-1" footer-classes="pb-2">
          <div class="col-md-12">
            <template v-for="(message) in alertMessages">
              <Alert :type = alertType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <template v-for="(message) in successMessages">
              <Alert :type = successType dismissible  v-if="message">  <span class="alert-inner--text">{{message}} </span>   <button type="button" class="close" data-dismiss="alert" aria-label="Close"> <span aria-hidden="true">&times;</span> </button> </Alert>
            </template>
            <validation-observer v-slot="{handleSubmit}" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="row">
                      <div class="col-md-12">
                        <base-input
                          :label="lang.label.code"
                          name="code"
                          :rules="{required: true}"
                          v-model="model.code"
                          autocomplete="off"
                          labelClasses="form-control-label asterisk-mark"
                        ></base-input>
                      </div>
                      <div class="col-md-12">
                       <base-input
                          :label="lang.label.queastion"
                          name="question"
                          :rules="{required: true}"

                          labelClasses="form-control-label asterisk-mark"
                        >
                        <html-editor v-model="model.name" autocomplete="off"> </html-editor>
                        </base-input>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="text-right mb-3">
                  <base-button type="primary" native-type="submit">{{lang.label.buttons.save}}</base-button>
                  <base-button
                    type="danger"
                    @click="$router.push({name: 'question'})"
                  >{{lang.label.buttons.cancel}}</base-button>
                </div>
              </form>
            </validation-observer>
          </div>
        </card>
      </div>
    </div>
    </template>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import HtmlEditor from '@/components/Inputs/HtmlEditor';
import Alert from "@/components/BaseAlert.vue";
import Notfound from "@/views/GeneralViews/NotFoundPage.vue";

export default {
  components: {
    RouteBreadCrumb,HtmlEditor,
    Alert,
    Notfound
  },
  data() {
    return {
       ID :this.$route.params.id,
      lang: this.$lang.question,
      loading: true,
       errored:false,
      model: {
        code: "",
        name: ""
      },
      alertType: 'danger',
      successType: 'success',
      alertMessages: [],
      successMessages: [],
    };
  },
mounted(){
  let self = this;
  let id = this.ID ;
     this.$store.dispatch('editQuestion',id)
                   .then(response => {
                      if (response.status == 200) {
                       this.model.name = response.data.Name;
                       this.model.code =response.data.Code;
                       this.loading = false;
                      }else{
                          if(response.status == 404){
                              this.errored = true;
                          }else{
                              if(typeof response.data.message != 'object'){
                                  this.alertMessages.push(response.data.message);
                              }else{
                                  let array = new Array();
                                  for (let key of Object.keys(response.data.message)) {
                                      let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                      array.push(obj)
                                  }
                                  this.alertMessages.push(array.join(', '));
                                  setTimeout(function () {
                                      self.alertMessages = [];
                                  },5000)
                              }
                          }
                          this.loading = false;
                      }
                        // this.$router.push({ path: "/" });
                    })
                    .catch(error => {
                        this.loading = false;
                    })
  },
  methods: {
    onSubmit() {
      let self = this;
      this.loading = true;
       let data = {
         "id" : this.ID,
         "Code" :this.model.code,
         "Name":this.model.name ,
            };
            this.$store.dispatch('updateQuestion', data)
                    .then(response => {
                     if (response.status == 200) {
                        this.flash({message: response.data.message, variant: 'success'});
                        this.$router.push({ name: "question" });
                        this.loading = false;
                     }else{
                         if(typeof response.data.message != 'object'){
                             this.alertMessages.push(response.data.message);
                         }else{
                             var array = new Array();
                             for (let key of Object.keys(response.data.message)) {
                                 let obj = response.data.message[key][0].includes('field') ? (key+"- "+response.data.message[key][0]) : response.data.message[key];
                                 array.push(obj)
                             }
                             self.alertMessages.push(array.join(', '));
                         }
                         setTimeout(function () {
                             self.alertMessages = [];
                         },5000)
                         self.loading = false;
                     }

                    })
                    .catch(error => {
                        this.loading = false;
                    })

    }
  }
};
</script>
<style>
.no-border-card .card-footer {
  border-top: 0;
}
.modal-header {
  padding-bottom: 0;
}
</style>
